<template>
  <!-- HDP -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]" :id="'test'+plytyp+'x'+bettyp">
    <div data-template="template2" class="wrap-template template2"> <!-- class 'is_rang' allbet clash -->
      <div class="main-handicap m-hdp">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ getTitleCaption() }}</span>
          </div>
          <div class="" v-if="newAllBetEvent.sprbinfo"><span class="ellipsis">{{ sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'] }}: {{ newAllBetEvent.sprbinfo.scoa }}-{{ newAllBetEvent.sprbinfo.scob }}</span></div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
            <template
              v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
              <div class="handicap">
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="item-label bet-ellipsis ellipsis" style="width:55%">
                            <span class="ellipsis-wrap" v-html="newAllBetEvent.oritacapt ? newAllBetEvent.oritacapt : newAllBetEvent.tacapt"></span>
                          </div>
                          <div>
                            <span class="bet_handicap yb-family-odds ellipsis vhighlight">
                              <handicap :event="newAllBetEvent" :favTeam="'a'" :plyType="plytyp" :betType="bettyp" :match="subMatchKey" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <odd :event="newAllBetEvent" :team="teamA" :plyType="plytyp" :betType="bettyp"
                        :match="subMatchKey" :ref="'teamA' + subMatchKey" :mode="'ab'"></odd>
                    </div>
                  </div>
                </div>
                <div class="handicap-item os-1">
                  <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                    <div class="bet-inner yb-flex-center fit">
                      <div class="handicap-wrap">
                        <div class="bet-item">
                          <div class="item-label bet-ellipsis ellipsis" style="width:55%">
                            <span class="ellipsis-wrap" v-html="newAllBetEvent.oritbcapt ? newAllBetEvent.oritbcapt : newAllBetEvent.tbcapt"></span>
                          </div>
                          <div>
                            <span class="bet_handicap yb-family-odds ellipsis vhighlight">
                              <handicap :event="newAllBetEvent" :favTeam="'b'" :plyType="plytyp" :betType="bettyp" :match="subMatchKey" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="bettyp"
                        :match="subMatchKey" :ref="'teamB' + subMatchKey" :mode="'ab'"></odd>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template> <!-- END submatch -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    /*rbinfo: {
      type: Boolean,
      default: false
    },*/
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().hdpBetType, allBetMixin.data().rhdpBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],  //game 1-5 playtype
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6',
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5',
      }
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = ''
      var title = ''
      var sCapt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H'
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP'
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP'
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') { /*** Set ***/
        a = '_' + this.pt[this.plytyp] + 'SET'
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {  /*** Game ***/
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME'
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS'
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS'
      }else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS'
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS'
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS'
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS'
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS'
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS'
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS'
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS'
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS'
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME'
      }

      var pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]  // Play Type
      var bt = this.sportAllBetLang['ALL_BET.SUBHEADER_HDP'] // Bet Type

      // RB score
      if (this.newAllBetEvent.event_rb == 1 && this.newAllBetEvent.rbinfo && this.newAllBetEvent.sptid == 1) {
        bt += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
      }

      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
        sCapt = ' '+ st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')'
      }
      return pt + bt + sCapt
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, hdpBetType) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, hdpBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, hdpBetType) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, hdpBetType, this.isSpecial)
    },
    // oddsHeader() {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.hdpBetType)
    //   }

    //   return retCapt
    // }
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-hdp.vue